import React from 'react';
import './LandingPage.css';

export default function AddUsers() {
  return (
    <main className="container" style={{ padding: 24 }}>
      <h1>Users</h1>
      <p>Manage users (placeholder).</p>
    </main>
  );
}
